<script>
	import { onMount } from 'svelte';
	import BannerGDPR from '../BannerGDPR.svelte';
	import { app } from '$lib/stores/app/store';
	import { setGdprVisibility } from '$lib/stores/app/actions';
	import Cookies from 'js-cookie';
	import { COOKIES } from '$lib/utils/constants';

	export let contentClassList = 'flex flex-grow w-full justify-center';

	onMount(() =>{
		setGdprVisibility($app.meta.viewerCountry);
	});
</script>

<div class="flex min-h-screen flex-col border-b-2 border-b-red-500">
	<header>
		<slot name="header"></slot>
	</header>

	<main class={contentClassList}>
		<slot name="content"></slot>
	</main>

	<footer>
		<slot name="footer"></slot>
	</footer>

	{#if $app.global.gdprVisible}
		<BannerGDPR />
	{/if}
</div>